import { Schema } from "mongoose"


type MongooseSchemaExtension = Parameters<Schema["add"]>[0]

export function extendMongooseSchema<TSchema extends Schema>(
  baseSchema: TSchema,
  ...extensions: MongooseSchemaExtension[]
): TSchema {
  const schema = baseSchema.clone() as TSchema

  extensions.forEach((extension) => schema.add(extension))

  return schema
}

export function omitMongooseSchemaPaths<TSchema extends Schema>(
  schema: TSchema,
  paths: string[],
): TSchema {
  const clone = schema.clone() as TSchema
  paths.forEach((path) => clone.remove(path))
  return clone
}
